/* =====================================================================
   SLEEK — scripts de la nouvelle page d'accueil + panier futuriste
   ===================================================================== */
(function () {
  'use strict';

  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var desk = window.matchMedia('(min-width: 990px)');
  var onMq = function (mq, fn) { mq.addEventListener ? mq.addEventListener('change', fn) : mq.addListener(fn); };
  var safePlay = function (v) {
    if (v.dataset && v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster);
    try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
  };

  /* ---------- vidéos : jouer seulement à l'écran ---------- */
  var io = null;
  function initVideos(root) {
    var vids = qsa('video[data-sk-lazy]', root);
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { if (v.dataset.skMedia === 'desktop' && !desk.matches) return; v.preload = 'auto'; safePlay(v); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (v.dataset.skMedia === 'desktop' && !desk.matches) return;
          if (e.isIntersecting) {
            if (v.preload === 'none') v.preload = 'auto';
            safePlay(v);
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { rootMargin: '250px 0px' });
    }
    vids.forEach(function (v) { io.observe(v); });
    if (!initVideos._vis) {
      initVideos._vis = true;
      /* le navigateur met parfois les vidéos en pause quand l'onglet est caché : on relance au retour */
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) return;
        qsa('video[data-sk-lazy]').forEach(function (v) {
          if (!v.paused || (v.dataset.skMedia === 'desktop' && !desk.matches)) return;
          var r = v.getBoundingClientRect();
          if (r.width && r.bottom > -250 && r.top < window.innerHeight + 250) safePlay(v);
        });
      });
    }
  }

  /* ---------- hero : fin de boucle + mobile/desktop ---------- */
  function initHero(root) {
    qsa('.sk-hero', root).forEach(function (h) {
      var mob = qs('.sk-hero__video', h);
      var frames = qsa('.sk-hero__frame video, video.sk-hero__wide', h);
      var apply = function () {
        if (desk.matches) {
          if (mob && !mob.paused) mob.pause();
          frames.forEach(function (f) {
            if (!f.paused) return;
            if (f.preload === 'none') f.preload = 'auto';
            safePlay(f);
          });
        } else {
          if (mob && mob.paused) safePlay(mob);
          frames.forEach(function (f) { if (!f.paused) f.pause(); });
        }
      };
      apply();
      onMq(desk, apply);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) return;
        var r = h.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) apply();
      });
      qsa('video[data-loop-end]', h).forEach(function (v) {
        var end = parseFloat(v.getAttribute('data-loop-end'));
        if (!(end > 0)) return;
        var check = function () { if (v.currentTime >= end) { v.currentTime = 0; safePlay(v); } };
        v.addEventListener('timeupdate', check);
        // image par image quand le navigateur le permet : la coupe tombe pile avant l'écran du logo
        if (v.requestVideoFrameCallback) {
          var tick = function () { check(); v.requestVideoFrameCallback(tick); };
          v.requestVideoFrameCallback(tick);
        }
      });
    });
  }

  /* ---------- ajout au panier (ouvre le tiroir du thème) ---------- */
  function toast(msg) {
    var t = qs('.sk-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'sk-toast';
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
  }

  function addToCart(variantId, qty, btn) {
    var drawer = qs('cart-drawer');
    if (btn) btn.classList.add('is-loading');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var body = {
      items: [{ id: Number(variantId), quantity: qty || 1 }],
      sections: drawer ? ['cart-drawer', 'cart-icon-bubble'] : [],
      sections_url: window.location.pathname
    };
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        var d = res.d;
        if (!res.ok || d.status) throw new Error(d.description || d.message || 'error');
        if (drawer && typeof drawer.renderContents === 'function' && d.sections) {
          var first = (d.items && d.items[0]) || {};
          drawer.renderContents({ id: first.product_id || variantId, sections: d.sections });
          drawer.classList.remove('is-empty');
          setTimeout(initCart, 60);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (btn) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          var lbl = qs('span', btn);
          if (lbl) {
            var old = lbl.textContent;
            lbl.textContent = btn.getAttribute('data-added') || 'Added';
            setTimeout(function () { lbl.textContent = old; btn.classList.remove('is-added'); }, 1800);
          }
        }
        document.dispatchEvent(new CustomEvent('sk:cart-added', { detail: d }));
      })
      .catch(function (err) {
        if (btn) btn.classList.remove('is-loading');
        toast((err && err.message && err.message !== 'error') ? err.message : ((window.cartStrings && window.cartStrings.error) || 'Error'));
      });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-sk-add]') : null;
    if (!b) return;
    e.preventDefault();
    if (b.classList.contains('is-loading')) return;
    addToCart(b.getAttribute('data-sk-add'), 1, b);
  });

  /* ---------- indicateurs de défilement des rails ---------- */
  function initRails(root) {
    qsa('[data-sk-rail]', root).forEach(function (rail) {
      var dots = rail.nextElementSibling;
      if (!dots || !dots.classList.contains('sk-swipe')) return;
      var marks = qsa('i', dots);
      if (!marks.length) return;
      var upd = function () {
        var max = rail.scrollWidth - rail.clientWidth;
        var p = max > 0 ? rail.scrollLeft / max : 0;
        var idx = Math.round(p * (marks.length - 1));
        marks.forEach(function (m, i) { m.classList.toggle('on', i === idx); });
      };
      rail.addEventListener('scroll', upd, { passive: true });
      upd();
    });
  }

  /* ---------- FAQ en mode DM ---------- */
  function initDM(root) {
    qsa('[data-sk-dm]', root).forEach(function (dm) {
      if (dm._sk) return;
      dm._sk = true;
      var body = qs('.sk-dm__body', dm);
      qsa('.sk-qchip', dm).forEach(function (chip) {
        chip.addEventListener('click', function () {
          var ans = qs('[data-sk-a="' + chip.getAttribute('data-sk-q') + '"]', dm);
          var me = document.createElement('p');
          me.className = 'sk-msg sk-msg--me is-new';
          me.textContent = chip.textContent.trim();
          body.appendChild(me);
          chip.hidden = true;
          var typing = document.createElement('div');
          typing.className = 'sk-typing';
          typing.innerHTML = '<i></i><i></i><i></i>';
          body.appendChild(typing);
          setTimeout(function () {
            typing.remove();
            var a = document.createElement('div');
            a.className = 'sk-msg sk-msg--them is-new';
            a.innerHTML = ans ? ans.innerHTML : '';
            body.appendChild(a);
          }, 750);
        });
      });
    });
  }

  /* ---------- quiz « Find your scent » (logique du site actuel) ---------- */
  function initQuiz(root) {
    qsa('[data-sk-quiz]', root).forEach(function (el) {
      if (el._sk) return;
      el._sk = true;
      var dataEl = qs('script[type="application/json"]', el);
      if (!dataEl) return;
      var D = JSON.parse(dataEl.textContent);
      var lang = (document.documentElement.lang || 'en').toLowerCase().indexOf('fr') === 0 ? 'fr' : 'en';
      var Q = D.questions[lang] || D.questions.en;
      var U = D.ui[lang] || D.ui.en;
      var cur = 0, ans = [];
      var $ = function (s) { return qs(s, el); };
      var bars = qsa('.sk-quiz__bar i', el);

      function render() {
        var q = Q[cur];
        $('.sk-quiz__top').textContent = U.qnum.replace('{n}', cur + 1);
        $('.sk-quiz__q').textContent = q.q;
        $('.sk-quiz__h').textContent = q.h;
        var box = $('.sk-quiz__opts');
        box.innerHTML = '';
        q.opts.forEach(function (o, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'sk-opt' + (ans[cur] === i ? ' on' : '');
          b.innerHTML = '<i style="background:' + (D.dots[i] || '#BA9939') + '"></i><span></span>';
          b.querySelector('span').textContent = o;
          b.addEventListener('click', function () {
            ans[cur] = i;
            qsa('.sk-opt', box).forEach(function (x, j) { x.classList.toggle('on', j === i); });
            next.disabled = false;
          });
          box.appendChild(b);
        });
        back.style.visibility = cur === 0 ? 'hidden' : 'visible';
        back.textContent = U.back;
        next.disabled = ans[cur] === undefined;
        next.innerHTML = '';
        next.appendChild(document.createTextNode(cur === Q.length - 1 ? U.result : U.next));
        bars.forEach(function (b, i) { b.classList.toggle('on', i <= cur); });
      }

      function show() {
        var key = ans[0] + ',' + ans[1];
        var r = D.results[key] || D.results['0,0'];
        $('.sk-quiz__res img').src = r.img;
        $('.sk-quiz__res img').alt = r.name;
        $('.sk-quiz__tag').textContent = U.tag;
        $('.sk-quiz__name').textContent = r.name;
        $('.sk-quiz__desc').textContent = lang === 'fr' ? r.fr : r.en;
        var add = $('.sk-quiz__add');
        var view = $('.sk-quiz__view');
        view.href = r.url;
        view.textContent = U.view;
        if (r.variant && r.available) {
          add.hidden = false;
          add.setAttribute('data-sk-add', r.variant);
          qs('span', add).textContent = U.add + (r.price ? ' · ' + r.price : '');
        } else {
          add.hidden = true;
        }
        $('.sk-quiz__again').textContent = U.restart;
        el.classList.add('is-done');
      }

      var next = $('.sk-qbtn--next');
      var back = $('.sk-qbtn--back');
      next.addEventListener('click', function () {
        if (ans[cur] === undefined) return;
        if (cur < Q.length - 1) { cur++; render(); } else { show(); }
      });
      back.addEventListener('click', function () { if (cur > 0) { cur--; render(); } });
      $('.sk-quiz__again').addEventListener('click', function () { cur = 0; ans = []; el.classList.remove('is-done'); render(); });
      render();
    });
  }

  /* ---------- suivi de commande (17TRACK, comme la page Track order) ---------- */
  var trackLoading = null;
  function loadTrack() {
    if (window.YQV5) return Promise.resolve();
    if (trackLoading) return trackLoading;
    trackLoading = new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = 'https://www.17track.net/externalcall.js';
      s.onload = res;
      s.onerror = rej;
      document.head.appendChild(s);
    });
    return trackLoading;
  }
  function initTrack(root) {
    qsa('[data-sk-track]', root).forEach(function (f) {
      if (f._sk) return;
      f._sk = true;
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = qs('input', f);
        var err = qs('.sk-terr', f.parentNode);
        var num = (input.value || '').trim();
        if (!num) { if (err) err.classList.add('show'); input.focus(); return; }
        if (err) err.classList.remove('show');
        var btn = qs('button', f);
        if (btn) btn.classList.add('is-loading');
        loadTrack().then(function () {
          if (btn) btn.classList.remove('is-loading');
          window.YQV5.trackSingle({
            YQ_ContainerId: f.getAttribute('data-sk-track'),
            YQ_Height: 560,
            YQ_Fc: '0',
            YQ_Lang: (document.documentElement.lang || 'en').slice(0, 2),
            YQ_Num: num
          });
        }).catch(function () {
          if (btn) btn.classList.remove('is-loading');
          window.open('https://t.17track.net/en#nums=' + encodeURIComponent(num), '_blank', 'noopener');
        });
      });
    });
  }

  /* ---------- bouton de langue flottant (en bas à gauche) ---------- */
  function initLang() {
    // dans l'éditeur de thème, la section peut être re-rendue : on garde seulement la plus récente
    var list = qsa('#sk-lang');
    var sw = list.filter(function (el) { return el.parentNode !== document.body; })[0] || list[0];
    list.forEach(function (el) { if (el !== sw) el.remove(); });
    if (!sw || sw._sk) return;
    sw._sk = true;
    if (sw.parentNode !== document.body) document.body.appendChild(sw);
    sw.hidden = false;
    // caché quand le choix de langue du footer est déjà à l'écran
    var foot = qs('.sk-foot .sk-lang');
    if (foot && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sw.classList.toggle('is-away', en[0].isIntersecting); }).observe(foot);
    }
  }

  /* ---------- bouton EN / FR + bulle panier : ils montent ensemble au-dessus des barres du bas ----------
     (barre « packs » mobile, ajout au panier collant, barre d'aperçu Shopify) → variable --sk-lift sur <html> */
  function initDock() {
    if (initDock._on) return;
    initDock._on = true;
    var busy = false;
    var lift = function () {
      busy = false;
      var vh = window.innerHeight, h = 0;
      var mb = qs('.sk-mbar.is-on');
      if (mb && mb.offsetHeight) h = (parseFloat(getComputedStyle(mb).bottom) || 0) + mb.offsetHeight;
      qsa('.sticky-atc, #PBarNextFrameWrapper').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.height && r.top < vh - 2 && r.bottom > vh - 140) h = Math.max(h, vh - r.top);
      });
      document.documentElement.style.setProperty('--sk-lift', Math.round(h) + 'px');
    };
    var req = function () { if (!busy) { busy = true; requestAnimationFrame(lift); } };
    var t = null;
    window.addEventListener('scroll', function () { req(); clearTimeout(t); t = setTimeout(lift, 500); }, { passive: true });
    window.addEventListener('resize', req);
    document.addEventListener('transitionend', function (e) {
      if (e.target && e.target.matches && e.target.matches('.sticky-atc, .sk-mbar')) lift();
    });
    setTimeout(lift, 700);
  }

  /* ---------- collection : tri ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel.matches || !sel.matches('[data-sk-sort]')) return;
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', sel.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  /* ---------- barre collante mobile ---------- */
  function initMbar() {
    var bar = qs('.sk-mbar');
    if (!bar || bar._sk) return;
    bar._sk = true;
    var hero = qs('.sk-hero');
    var upd = function () {
      var h = hero ? hero.offsetHeight : 600;
      var foot = qs('.sk-foot');
      var footTop = foot ? foot.getBoundingClientRect().top : Infinity;
      bar.classList.toggle('is-on', window.scrollY > h * 0.75 && footTop > window.innerHeight - 40);
    };
    window.addEventListener('scroll', upd, { passive: true });
    upd();
  }

  /* ---------- panier : animations de la jauge ---------- */
  function initCart() {
    var g = qs('cart-drawer .skc-gauge');
    if (g) {
      var fill = qs('.skc-fill', g);
      if (fill && fill.dataset.p) {
        requestAnimationFrame(function () { fill.style.setProperty('--p', fill.dataset.p + '%'); });
      }
    }
  }
  // le thème re-rend le tiroir après chaque changement : on relance la jauge
  var drawerEl = qs('cart-drawer');
  if (drawerEl && 'MutationObserver' in window) {
    new MutationObserver(function () { initCart(); }).observe(drawerEl, { childList: true, subtree: true });
  }

  function init(root) {
    initLang();
    initDock();
    initHero(root);
    initVideos(root);
    initRails(root);
    initDM(root);
    initQuiz(root);
    initTrack(root);
    initMbar();
    initCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();